import React, { Fragment } from 'react';
import * as Yup from 'yup';
import NumberFormat from 'react-number-format';

import { makeStyles } from '@material-ui/core/styles';
import { Formik } from 'formik';

import {
    Select,
    InputLabel,
    MenuItem,
    FormControl,
    Box,
    Grid,
    colors,
    Typography,
    Divider,
    Dialog,
    DialogContent,
    DialogTitle,
    Button,
    TextField,
    Switch,
    Avatar
} from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    root: {
    },
    avatar: {
        marginRight: theme.spacing(2),
        marginTop: theme.spacing(2),
        color: colors.cyan[300],
        backgroundColor: colors.grey[200],
        width: 290,
        height: 290
    }
}));

const ItemOrcamento = ({ item, open, closeEdition, updateValues, dependencies }) => {

    const classes = useStyles();

    return (
        <Fragment>

            <Dialog aria-modal="true" open={open} aria-labelledby="form-dialog-title" maxWidth="md" className={classes.root} >
                <DialogTitle id="form-dialog-title">
                    <Typography
                        color="textPrimary"
                        variant="h4">
                        Produto
                    </Typography>
                </DialogTitle>

                <DialogContent dividers={true}>

                    <Formik
                        initialValues={item}
                        validationSchema={
                            Yup.object().shape({
                                nome: Yup.string().required('O nome do produto é obrigatório'),
                                ORIGEM: Yup.string().required('O Tipo do produto é obrigatório'),
                                UNIDADE: Yup.string().required('A Unidade do produto é obrigatória'),
                                qtd: Yup.string().required('A Quantidade é precisa ser informada'),
                                valor: Yup.number().min(0.0).required('O Valor do produto é obrigatório'),
                                instalacao: Yup.number().required('O Valor de Mão de Obra do produto é obrigatório'),
                            }
                            )
                        }
                        onSubmit={(values, formik) => {
                            updateValues(values);
                            formik.setSubmitting(false);
                        }}

                    >

                        {({
                            errors,
                            handleBlur,
                            handleChange,
                            setFieldValue,
                            handleSubmit,
                            isSubmitting,
                            touched,
                            values
                        }) => (
                            <form onSubmit={handleSubmit}>


                                <Grid
                                    container
                                    spacing={2}
                                    xs="auto"
                                >
                                    <Grid
                                        item
                                        md={2}
                                        xs={12}>

                                        <TextField
                                            error={Boolean(touched.codigo && errors.codigo)}
                                            fullWidth
                                            required={false}
                                            label="Código"
                                            margin="none"
                                            name="codigo"
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            value={values.codigo}
                                            variant="outlined"
                                            InputLabelProps={{ shrink: true }}
                                        />

                                    </Grid>

                                    <Grid
                                        item
                                        md={10}
                                        xs={12}>

                                        <TextField
                                            error={Boolean(touched.nome && errors.nome)}
                                            fullWidth
                                            required
                                            label="Nome"
                                            margin="none"
                                            name="nome"
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            value={values.nome}
                                            variant="outlined"
                                            InputLabelProps={{ shrink: true }}
                                        />

                                    </Grid>


                                    <Grid
                                        item
                                        md={4}
                                        xs={12}>

                                        <FormControl variant="outlined" fullWidth margin="none" >
                                            <InputLabel shrink htmlFor="ORIGEM" required>Tipo</InputLabel>
                                            <Select notched
                                                autosize={true}
                                                required
                                                error={Boolean(touched.ORIGEM && errors.ORIGEM)}
                                                value={values.ORIGEM}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                label="Tipo"
                                                variant="outlined"
                                                inputProps={{
                                                    name: 'ORIGEM',
                                                    id: 'ORIGEM',
                                                }}
                                            >
                                                <MenuItem value={null}>
                                                    <em>Selecione uma das opções abaixo</em>
                                                </MenuItem>

                                                {dependencies.origins.map((regiao) => (
                                                    <MenuItem key={regiao.id} value={regiao.id}>{regiao.nome}</MenuItem>
                                                ))}

                                            </Select>
                                        </FormControl>

                                    </Grid>

                                    <Grid
                                        item
                                        md={4}
                                        xs={12}>

                                        <FormControl variant="outlined" fullWidth>
                                            <InputLabel shrink htmlFor="APLICACAO">Categoria</InputLabel>
                                            <Select notched
                                                autosize={true}
                                                error={Boolean(touched.APLICACAO && errors.APLICACAO)}
                                                value={values.APLICACAO}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                label="Categoria"
                                                variant="outlined"
                                                inputProps={{
                                                    name: 'APLICACAO',
                                                    id: 'APLICACAO',
                                                }}
                                            >
                                                <MenuItem value={null}>
                                                    <em>Selecione uma das opções abaixo</em>
                                                </MenuItem>
                                                {dependencies.applications.map((regiao) => (
                                                    <MenuItem key={regiao.id} value={regiao.id}>{regiao.nome}</MenuItem>
                                                ))}

                                            </Select>
                                        </FormControl>

                                    </Grid>

                                    <Grid
                                        item
                                        md={12}
                                        xs={12}>
                                        <Divider></Divider>
                                    </Grid>

                                    <Grid
                                        item
                                        md={3}
                                        xs={12}>
                                        <NumberFormat
                                            error={Boolean(touched.qtd && errors.qtd)}
                                            fullWidth
                                            required
                                            label="Quantidade"
                                            margin="none"
                                            name="qtd"
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            value={values.qtd}
                                            variant="outlined"
                                            decimalScale="2"
                                            fixedDecimalScale="true"
                                            customInput={TextField}
                                            InputLabelProps={{ shrink: true }}
                                        />

                                    </Grid>

                                    <Grid
                                        item
                                        md={3}
                                        xs={12}>

                                        <FormControl variant="outlined" fullWidth>
                                            <InputLabel shrink htmlFor="UNIDADE" required>Unidade</InputLabel>
                                            <Select notched
                                                autosize={true}
                                                required
                                                error={Boolean(touched.UNIDADE && errors.UNIDADE)}
                                                value={values.UNIDADE}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                label="Unidade"
                                                variant="outlined"
                                                inputProps={{
                                                    name: 'UNIDADE',
                                                    id: 'UNIDADE',
                                                }}
                                            >
                                                <MenuItem value={null}>
                                                    <em>Selecione uma das opções abaixo</em>
                                                </MenuItem>
                                                {dependencies.units.map((unit) => (
                                                    <MenuItem key={unit.id} value={unit.id}>{unit.nome}</MenuItem>
                                                ))}

                                            </Select>
                                        </FormControl>

                                    </Grid>

                                    <Grid
                                        item
                                        md={3}
                                        xs={12}>
                                        <NumberFormat
                                            error={Boolean(touched.valor && errors.valor)}
                                            fullWidth
                                            required
                                            label="Valor Material"
                                            margin="none"
                                            name="valor"
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            value={values.valor}
                                            variant="outlined"
                                            decimalScale="2"
                                            fixedDecimalScale="true"
                                            customInput={TextField}
                                            InputLabelProps={{ shrink: true }}
                                        />

                                    </Grid>

                                    <Grid
                                        item
                                        md={3}
                                        xs={12}>

                                        <NumberFormat
                                            error={Boolean(touched.instalacao && errors.instalacao)}
                                            fullWidth
                                            required
                                            label="Valor Instalação"
                                            margin="none"
                                            name="instalacao"
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            value={values.instalacao}
                                            variant="outlined"
                                            decimalScale="2"
                                            fixedDecimalScale="true"
                                            customInput={TextField}
                                            InputLabelProps={{ shrink: true }}
                                        />

                                    </Grid>

                                </Grid>


                                <Box my={1}></Box>
                                <Divider />

                                <Box my={1}>
                                    <Grid container
                                        direction="row"
                                        justify="flex-end"
                                        alignItems="baseline"
                                        spacing={1}  >
                                        <Grid item >
                                            <Button
                                                color="secondary"
                                                disabled={isSubmitting}
                                                size="small"
                                                type="submit"
                                                variant="contained">
                                                Salvar
                                            </Button>
                                        </Grid>
                                        <Grid item >
                                            <Button
                                                color="secondary"
                                                disabled={isSubmitting}
                                                size="small"
                                                variant="contained"
                                                onClick={() => { closeEdition() }}>
                                                Cancelar
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Box>

                            </form>
                        )}
                    </Formik>

                </DialogContent>

            </Dialog>

        </Fragment >
    );
};

export default ItemOrcamento;
